import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postCustomersURL } from "../utils/api";
import { useReactToPrint } from 'react-to-print';
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Image,
    Table,
    Thead,
    Tfoot,
    Tbody,
    Th,
    Tr,
    Td,
    VStack,
} from "@chakra-ui/react";
import EasyChekLogo from "assets/images/easychek_logo.jpg";
import OrdersTable from "views/Custom/OrdersTable";
// import Pagination from "views/Custom/Pagination";
// import useGetOrders from "hooks/useGetOrders";

function OrderHistory({
    isOpen,
    onClose,
    userData,
}) {


    useEffect(() => {
        if (userData && isOpen) {
            console.log(userData);
        }
    }, [userData, isOpen]);

    // console.log(partsTotal, laborTotal);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    if (userData == null) {
        return (<></>);
    }

    const customer = userData.companyName 
        ? userData.companyName 
        : `${userData.firstName} ${userData.lastName}` 

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{customer} Order History</ModalHeader>
                <ModalCloseButton />
                <ModalBody width={"100%"}p={"32px"}>
                    <Flex direction={"column"}>
                        <OrdersTable 
                            customerId={userData.id}
                        />
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default OrderHistory;
